//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"DepthMode",1,0],[0,"DepthPerCut",1,0],[1,"Distance",0,"CAM.InheritableToolDepBuilder",0],[0,"EndPercent",1,0],[0,"FinishPassAtEnd",1,0],[0,"FinishPassAtStart",1,0],[0,"HubExtensions",1,0],[0,"IncompleteLevels",1,0],[0,"NumberOfCuts",1,0],[0,"NumberOfIntermediateCuts",1,0],[0,"RangeDepth",1,0],[0,"ReduceDepthPerCutWhenEmbeded",1,0],[1,"ScallopDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"StartPercent",1,0],[0,"StripeEndPercent",1,0],[0,"StripeStartPercent",1,0],[0,"StripeType",1,0]],[],[]];
SPLM.CAM.BladeCutLevels = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BladeCutLevels";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BladeCutLevels.DepthModeTypes = Object.freeze({
    "OffsetsFromHub" : "OffsetsFromHub", "OffsetsFromShroud" : "OffsetsFromShroud", "OffsetsAlongToolAxis" : "OffsetsAlongToolAxis", "InterpolateFromShroudToHub" : "InterpolateFromShroudToHub"});

SPLM.CAM.BladeCutLevels.HubExtensionsTypes = Object.freeze({
    "None" : "None", "ToPreviousDepth" : "ToPreviousDepth", "ToTrailingEdge" : "ToTrailingEdge"});

SPLM.CAM.BladeCutLevels.DepthPerCutTypes = Object.freeze({
    "Constant" : "Constant", "Scallop" : "Scallop"});

SPLM.CAM.BladeCutLevels.RangeDepthTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify", "MultiStripes" : "MultiStripes"});

SPLM.CAM.BladeCutLevels.StripeTypes = Object.freeze({
    "Top" : "Top", "Intermediate" : "Intermediate", "Bottom" : "Bottom"});

SPLM.CAM.BladeCutLevels.IncompleteLevelsTypes = Object.freeze({
    "OutputAndWarn" : "OutputAndWarn", "Omit" : "Omit"});

export default SPLM;